module.exports = __webpack_public_path__ + "img/minAd01.55b66d5e.png";